import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
    }

    addPhoneField(event) {
        event.preventDefault()

        const phoneContainer = document.getElementById('phone-numbers')
        const time = new Date().getTime()
        const newPhoneFieldset = document.createElement('div')
        newPhoneFieldset.className = 'phone-number-fields grid grid-cols-1 md:grid-cols-3 gap-6 mb-4 pb-4 border-b border-slate-200 dark:border-slate-700'
        newPhoneFieldset.innerHTML = `
      <div class="form-group">
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" for="member_user_attributes_phone_numbers_attributes_${time}_phone_label">Phone Type</label>
        <select class="form-input sm:pr-12 shadow-xs w-full" name="member[user_attributes][phone_numbers_attributes][${time}][phone_label]" id="member_user_attributes_phone_numbers_attributes_${time}_phone_label">
          <option value="Mobile">Mobile</option>
          <option value="Home">Home</option>
          <option value="Work">Work</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div class="form-group">
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" for="member_user_attributes_phone_numbers_attributes_${time}_phone">Phone Number</label>
        <input class="form-input" type="tel" name="member[user_attributes][phone_numbers_attributes][${time}][phone]" id="member_user_attributes_phone_numbers_attributes_${time}_phone" placeholder="Phone Number">
      </div>

      <div class="form-group mt-8">
        <label class="inline-flex items-center">
          <input name="member[user_attributes][phone_numbers_attributes][${time}][display_number]" type="hidden" value="0">
          <input class="form-checkbox" type="checkbox" value="1" name="member[user_attributes][phone_numbers_attributes][${time}][display_number]" id="member_user_attributes_phone_numbers_attributes_${time}_display_number">
          <span class="ml-2 text-sm text-slate-700 dark:text-slate-300">Primary Phone</span>
        </label>
        <input type="hidden" name="member[user_attributes][phone_numbers_attributes][${time}][_destroy]" value="0">
        <button type="button" class="btn btn-sm btn-danger ml-4" data-action="click->phone-numbers#removePhoneField">
          Remove
        </button>
      </div>
    `

        phoneContainer.appendChild(newPhoneFieldset)
    }

    removePhoneField(event) {
        event.preventDefault()

        const fieldset = event.target.closest('.phone-number-fields')
        const destroyField = fieldset.querySelector('input[name$="[_destroy]"]')
        destroyField.value = "1"
        fieldset.style.display = 'none'
    }
}
